<template>
  <div class="container-processos-pesquisa">
    <h2 class="texto-processos-pesquisa">Pesquisa de Pregões Eletrônicos</h2>
    <v-layout wrap align-center>
      <v-flex xs12 sm12 md4 d-flex>
        <v-text-field
            v-model="filtros.objeto"
            name="pesquisa-objeto"
            placeholder="Objeto"
            outline
            class="processos-pesquisa-textfield"
        />
      </v-flex>
      <v-flex xs12 sm12 md2 d-flex>
        <v-autocomplete
            v-model="filtros.estado"
            name="pesquisa-estado"
            placeholder="Estado"
            class="processos-pesquisa-autocomplete"
            outline
            :items="estadoItems"
            item-text="nome"
            item-value="sigla"
            :filter="filtroComboAutoCompleteEstadoItems"
            @change="buscarMunicipios"
        />
      </v-flex>
      <v-flex xs12 sm12 md2 d-flex>
        <v-autocomplete
            v-model="filtros.idMunicipio"
            name="pesquisa-cidade"
            placeholder="Cidade"
            class="processos-pesquisa-autocomplete"
            outline
            :items="cidadeItems"
            item-text="descricao"
            item-value="idMunicipio"
            no-data-text="Não há cidades para o estado selecionado"
            :filter="filtroComboAutoCompleteCidadeItems"
        />
      </v-flex>
      <v-flex xs12 sm12 md2 d-flex>
        <az-combo-enum-licitacao
            v-model="filtros.status"
            name="pesquisa-situacao"
            placeholder="Situação"
            :enum-object="situacaoItems"
            class="processos-pesquisa-combo-enum"
            outline
        />
      </v-flex>
      <v-flex xs12 sm12 md2 d-flex>
        <v-btn depressed @click="buscarFiltros" class="processos-pesquisa-btn">Buscar</v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>

import AzComboEnumLicitacao from '@/views/components/AzComboEnumLicitacao.vue'
import {mapActions} from 'vuex'
import {actionTypes} from '@/core/constants'

export default {
  name: 'ListagemProcessosLicitacaoPesquisa',
  components: {AzComboEnumLicitacao},
  props: ['filtros'],
  data() {
    return {
      estadoItems: [],
      cidadeItems: [],
      situacaoItems: {
        'AGUARDANDO_ABERTURA': 'Aguardando abertura',
        'ABERTO': 'Aberta',
        'SUSPENSO': 'Suspensa',
        'ENCERRADO': 'Encerrada'
      }
    }
  },
  async mounted() {
    await this.buscarEstados()
  },
  methods: {
    ...mapActions([
      actionTypes.BUSCAR_ESTADOS_EFORNECEDOR,
      actionTypes.BUSCAR_MUNICIPIOS_POR_ESTADO
    ]),
    async buscarEstados() {
      this.estadoItems = await this.buscarEstadosEfornecedor()
    },
    async buscarMunicipios() {
      this.filtros.idMunicipio = null
      this.cidadeItems = await this.buscarMunicipiosPorEstado(this.filtros.estado)
    },
    filtroComboAutoCompleteEstadoItems(item, queryText) {
      const text = item.nome.toLowerCase()
      const searchText = queryText.toLowerCase()
      return text.indexOf(searchText) > -1
    },
    filtroComboAutoCompleteCidadeItems(item, queryText) {
      const text = item.descricao.toLowerCase()
      const searchText = queryText.toLowerCase()
      return text.indexOf(searchText) > -1
    },
    buscarFiltros() {
      this.$emit('buscarComFiltros')
    }
  }
}
</script>

<style scoped lang="stylus">

.container-processos-pesquisa
  background-color #F9F9F9
  padding 30px 10%

.texto-processos-pesquisa
  font-size 18px
  margin-bottom 20px

.processos-pesquisa-textfield
  >>> .v-input__slot
    background-color #fff !important
    font-weight 400 !important
    line-height 1.5 !important
    color #212529
    background-clip padding-box !important
    border 1px solid #ced4da !important
    border-radius 4px

    input
      padding 0px !important

.processos-pesquisa-autocomplete
  margin-left -3px

  >>> .v-input__slot
    background-color #fff !important
    font-weight 400 !important
    line-height 1.5 !important
    color #212529
    background-clip padding-box !important
    padding-right 0px !important
    border 1px solid #ced4da !important
    height 30px
    border-radius 4px

.processos-pesquisa-combo-enum
  margin-left -3px

  >>> .v-input__slot
    background-color #fff !important
    font-weight 400 !important
    line-height 1.5 !important
    background-clip padding-box !important
    padding-right 0px !important
    border 1px solid #ced4da !important
    height 30px
    border-radius 4px

  >>> .v-select__selections
    color #9E9E9E

.processos-pesquisa-btn
  text-transform none
  background-color #1577AA !important
  color #fff
  font-weight 400
  width 200px
  height 56px
  margin 0px
  margin-left -1px
  margin-bottom 28px

</style>
